import SimpleCard, { SimpleCardProps } from './SimpleCard';

export type { SimpleCardProps };
export default SimpleCard;
